export enum SessionEvent {
    StartMainSession = 'session_start',
    StartPlanSession = 'plan_session_start',
    EndMainSession = 'end_session',
    EndPlanSession = 'plan_end_session',
}
